import { render, staticRenderFns } from "./Expenses.vue?vue&type=template&id=20d627d0"
import script from "./Expenses.vue?vue&type=script&lang=js"
export * from "./Expenses.vue?vue&type=script&lang=js"
import style0 from "./Expenses.vue?vue&type=style&index=0&id=20d627d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports